import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow--circled-right",
  "use": "icon-arrow--circled-right-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 28\" id=\"icon-arrow--circled-right\"><circle cx=\"14.401\" cy=\"14\" r=\"12.5\" stroke=\"#262626\" stroke-width=\"2\" /><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"m16.657 9.518 4.211 4.211a.662.662 0 0 1 0 .936l-4.211 4.212a.662.662 0 1 1-.936-.936l3.082-3.082H8.489v-1.324h10.314l-3.082-3.081a.662.662 0 1 1 .936-.936Z\" fill=\"#262626\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol